// One-line resume nudge for visitors who've seen the welcome but
// haven't completed any skills yet. Single CTA, live pot, playful
// copy — no secondary text competing for attention.
import { useState } from "react";
import { Trophy, ArrowRight } from "lucide-react";
import { useBeginnerMode } from "@/hooks/useBeginnerMode";
import { useHackathon, formatUsd } from "@/hooks/useHackathon";
import WelcomeOnboardingModal from "./WelcomeOnboardingModal";

const BeginnerStartBanner = () => {
  const { active, completed, welcomeSeen, currentNum, start, markWelcomeSeen } =
    useBeginnerMode();
  const { pot } = useHackathon({ scoreboardLimit: 1 });
  const [welcomeOpen, setWelcomeOpen] = useState(false);

  const handleClick = () => {
    if (welcomeSeen) start();
    else setWelcomeOpen(true);
  };

  const handleFinishWelcome = () => {
    markWelcomeSeen();
    setWelcomeOpen(false);
    start();
  };

  if (active || completed.length > 0) return null;

  const potLabel = pot ? formatUsd(pot.pot_cents) : "$10,427";
  const skillNum = currentNum || 1;

  return (
    <>
      <WelcomeOnboardingModal
        open={welcomeOpen}
        onClose={() => setWelcomeOpen(false)}
        onFinish={handleFinishWelcome}
      />
      <button
        type="button"
        onClick={handleClick}
        className="group block w-full border-b border-primary/30 bg-gradient-to-r from-primary/15 via-primary/10 to-transparent hover:from-primary/20 hover:via-primary/15 transition-colors"
      >
        <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-2 text-xs sm:text-sm font-mono">
          <Trophy className="w-3.5 h-3.5 text-primary shrink-0" />
          <span className="text-foreground">
            Pot's at{" "}
            <span className="text-primary font-bold tabular-nums">{potLabel}</span>.
            <span className="hidden sm:inline"> Skill #{skillNum} unlocks the game.</span>
          </span>
          <span className="inline-flex items-center gap-0.5 text-primary font-semibold group-hover:underline underline-offset-2">
            Play <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </div>
      </button>
    </>
  );
};

export default BeginnerStartBanner;
